import Api from '@/services/Api'

export default {
  setTempPassword (resetData) {
    return Api().post('user/forgotpassword/temp', resetData)
  },
  emailTempPassword (emailPassword) {
    return Api().post('user/forgotpassword/email', emailPassword)
  }
}



// WEBPACK FOOTER //
// ./src/services/ForgotPasswordService.js